import axios from 'axios';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import './index.css';

const FormItalian = () => {
  const { register, handleSubmit, reset, errors } = useForm();
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: any) => {
    setLoading(true);
    setSent(false);

    const config: any = {
      method: 'post',
      url: 'https://drinking.uk/v1/api/contact/venue',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        company_name: data.companyName,
        email: data.email,
        first_name: data.firstName,
        last_name: data.lastName,
        message: data.message,
      }),
    };
    axios(config)
      .then(function (response) {
        setSent(true);
        reset();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div id='form'>
      <div className='form__desc'>
        <h2>Vuoi accettare DrinKing presso la tua sede?</h2>
        <p>
          Grazie ai nostri costi di installazione zero e all'attrezzatura minima richiesta per far funzionare il nostro sistema, puoi richiedere di organizzare un giorno per configurare una prova gratuita e una demo per vedere se funziona per te prima di prendere impegni finanziari.
        </p>
        <p> Porta la tua sede nel 21° secolo compilando il modulo!</p>
      </div>
      <form className='emailForm' onSubmit={handleSubmit(onSubmit)}>
        <h3>Vi preghiamo di inviarci un'e-mail utilizzando il modulo sottostante.</h3>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '49%' }}
          >
            <input
              name='firstName'
              type='text'
              ref={register({ required: true, minLength: 2, maxLength: 64 })}
              placeholder='Nome di battesimo'
            />
            {errors && errors?.firstName && (
              <span>Il campo Nome è obbligatorio</span>
            )}
          </div>
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '49%' }}
          >
            <input
              name='lastName'
              type='text'
              ref={register({ required: true, minLength: 2, maxLength: 64 })}
              placeholder='Cognome'
            />
            {errors && errors?.lastName && (
              <span>Il campo Cognome è obbligatorio</span>
            )}
          </div>
        </div>
        <input
          name='email'
          type='email'
          ref={register({ required: true, maxLength: 128 })}
          placeholder='E-mail'
        />
        {errors && errors?.email && <span> Il campo E-mail è obbligatorio</span>}
        <input
          name='companyName'
          type='text'
          ref={register({ required: true, minLength: 2, maxLength: 64 })}
          placeholder='Nome commerciale'
        />
        {errors && errors?.companyName && (
          <span>Il campo Nome commerciale è obbligatorio</span>
        )}
        <textarea
          name='message'
          ref={register({ required: true, minLength: 2, maxLength: 1024 })}
          placeholder='Messaggio'
          rows={4}
          cols={50}
        />
        {errors && errors?.message && <span> Il campo Messaggio è obbligatorio</span>}
        <input type='submit' disabled={loading} />
        {sent && (
          <p style={{ textAlign: 'center', marginTop: 0 }}>
            La tua richiesta è stata inviata. Grazie!
          </p>
        )}
      </form>
    </div>
  );
};

export default FormItalian;
